export default{
    portalUrl: "https://beta.promineo-portal.promineo.no/api/",
    portalReadTokenUrl: "https://beta.promineo-portal.promineo.no/api/azureadtoken"
}